import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 20H3v1c0 .558.441 1 .991 1h2.512c.28 0 .497.224.497.5 0 .268-.222.5-.497.5H3.991A1.99 1.99 0 0 1 2 21V2.895C2 1.848 2.89 1 3.991 1h17.007C21.55 1 22 1.417 22 1.949V21.99A1 1 0 0 1 20.998 23H13.5c-.27 0-.5-.224-.5-.5 0-.268.224-.5.5-.5 0 0 7.5.002 7.5-.01V20h-9v3.738c0 .277-.157.345-.348.154L10 22.24l-1.652 1.652c-.192.192-.348.123-.348-.154V20zm-3-1h16V2H5v17zm-1 0V2h-.108A.89.89 0 0 0 3 2.89V19h1zm13-8.05v4.051c0 .552-.453.999-.997.999H9.997A.995.995 0 0 1 9 15.001V10.95a2.5 2.5 0 1 1 1.143-4.867 3.001 3.001 0 0 1 5.714 0A2.504 2.504 0 0 1 19 8.5a2.5 2.5 0 0 1-2 2.45zM11 7H9.5a1.5 1.5 0 1 0 .5 2.915V13h6V9.915A1.5 1.5 0 1 0 16.5 7H15a2 2 0 1 0-4 0zm-1 8h6.003C16 15 16 14 16 14h-6v1z"
});

var SvgRecipes = function SvgRecipes(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgRecipes;